<alaris-dialog
	[closeAction]="close.bind(this)"
	[confirmAction]="confirm.bind(this)"
	[loading$]="clientsService.loading$"
	[confirmButtonText]="'gl.delete'"
	size="md"
	class="removingDialog">
	<h3 slot="header">
		<app-circle-warning></app-circle-warning>
		<div>
			{{ 'clients.removingDialogTitle' | translate }}
		</div>
	</h3>
	<div slot="content">
		<p>
			{{ 'clients.removingDialog' | translate }}
			<strong>{{ data.client.login }}</strong>
		</p>
	</div>
</alaris-dialog>
